import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
      <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-400 via-primary-500 to-accent-500 flex items-center justify-center gold-glow">
        <i className="ri-vip-diamond-line text-background-950 text-xl"></i>
      </div>
      <span className="font-logo text-xl font-bold tracking-wide text-gold-gradient whitespace-nowrap">
        Goldsbvvn
      </span>
    </Link>
  );
}